// extracted by mini-css-extract-plugin
module.exports = {"text":"PatientNotesList_text__13AxX","footer":"PatientNotesList_footer__wDkd5"};